/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon16Solid = forwardRef('TimeClockMoveBackIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.318 3.177a5 5 0 0 0-5.32 1.827h.766a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1V2.779a1 1 0 0 1 2 0V3.1a7 7 0 1 1-1.332 7.884 1 1 0 0 1 1.81-.853 5 5 0 1 0 5.84-6.955Z" }),
        React.createElement("path", { d: "M9 4.995a1 1 0 1 0-2 0v2.378a2 2 0 0 0 1.128 1.8l2.134 1.035a1 1 0 1 0 .872-1.8L9 7.373V4.995Z" })));
});
